import React, {useState} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import actions from 'redux-auto'
import IconButton from '#components/a/IconButton'
import {TriggerWithTooltip} from '#components/m/MeineAzubis/TriggerWithTooltip'
import {getWindow} from '#helpers/window'
import Api from '#services/api'

export function MailToAusbilder(props) {
  const [ausbilderEmailAdress, setAusbilderEmailAdress] = useState()

  const getAusbilderEmailAddress = async () => {
    const {azubi} = props
    if (!ausbilderEmailAdress) {
      try {
        const allAzubiAusbilder = await Api.getAusbilderAsTrainer(azubi.id)
        const ausbilderWithValidEmail = allAzubiAusbilder.filter(x => x.email)[0]
        setAusbilderEmailAdress(ausbilderWithValidEmail ? ausbilderWithValidEmail.email : null)
      } catch (e) {
        actions.error.writeError({error: e})
      }
    }
  }

  const onMailButtonClicked = () => {
    if (ausbilderEmailAdress) {
      getWindow().open(`mailto:${ausbilderEmailAdress}`)
    } else {
      props.updateParentState()
    }
  }

  return (
    <div onMouseEnter={getAusbilderEmailAddress}>
      <TriggerWithTooltip
        text={i18n.t('meineazubis_contactausbilder_tooltip')}
        modifiers={['dark', 'nopadding', 'sendmail']}
      >
        <IconButton
          icon="mail"
          event={() => {
            onMailButtonClicked()
          }}
        />
      </TriggerWithTooltip>
    </div>
  )
}

MailToAusbilder.propTypes = {
  azubi: PropTypes.object.isRequired,
  updateParentState: PropTypes.func.isRequired,
}
